module.exports = [{
      plugin: require('/Users/dsaewitz/y/gamehendge/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":1140,"quality":90,"linkImagesToOriginal":false},
    },{
      plugin: require('/Users/dsaewitz/y/gamehendge/node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://saewitz.com/gamehendge"},
    }]
